<mat-card appearance="outlined" class="container-fluid container">
  <mat-card-title class="container-header header_popup">
    <span class="title">{{Title}}</span>
    <div class="align-items-start subheader">
      <h4 [innerHTML]="SubTitle"></h4>
      <hr>
    </div>
  </mat-card-title>
  <mat-card-content class="container-content content">
    <form name="form" #f="ngForm">
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="col-12">
              <app-upload accept=".pdf" single="true"></app-upload>
            </div>
          </div>
        </div>
      </div>
    </form>
  </mat-card-content>
  <mat-card-footer class="container-footer">
    <div class="modal-footer d-table w-100">
      <div class="d-table-cell">
        <button tabindex="-1" mat-stroked-button class="currentBtn" (click)="close(false);">Annuler</button>
      </div>
      <div class="d-table-cell tar">
        <button tabindex="-1" mat-stroked-button class="currentBtnColor" [disabled]="!hasFiles" (click)="onSubmit()">Valider</button>
      </div>
    </div>
  </mat-card-footer>
</mat-card>